<template>
  <vue100vh style="position: fixed; width: 100%;">
  <div class="CSChatThai BGwhite">
    <v-toolbar style="background-color: white !important;">
      <v-btn icon @click="toPage('/mobile/homepage')">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-toolbar-title>{{$t('HeaderMenubar.editProfile')}}</v-toolbar-title>
    </v-toolbar>
      <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important; overflow-y: scroll; max-height: 94vh; color: rgb(74, 74, 74) !important;">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm12 md12 lg12 xl12 style="display: flex; justify-content: center;">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12 lg12 xl12 style="display: flex !important; justify-content: center !important;">
                    <ul class="List_Register">
                      <li  class="List_item">
                        <!-- <div class="List_item_header">
                        </div>  -->
                        <div  class="List_item_body">
                          <div class="SettingImg" style="justify-content: center; display: flex;">
                            <div class="SettingImgWrap">
                              <v-layout align-center justify-center column>
                                <img :src="profilepicture" class="alligator-turtle" @click="uppic" v-if="profilepicture !== ''" style=" cursor: pointer;width: 100px;height: 100px;">
                                <img src='/static/img/default_profile/man-white.png' class="alligator-turtle" style=" cursor: pointer;width: 100px;height: 100px;" v-else-if="typeuser === 'user'" @click="uppic">
                                <img src='/static/img/default_profile/business-white.png' class="alligator-turtle" style=" cursor: pointer;width: 100px;height: 100px;" v-else-if="typeuser === 'government'" @click="uppic">
                                <img src='/static/img/default_profile/business-white.png' class="alligator-turtle" style=" cursor: pointer;width: 100px;height: 100px;" v-else-if="typeuser === 'business'" @click="uppic">
                                <img src='/static/img/default_profile/man-white.png' class="alligator-turtle" style=" cursor: pointer;width: 100px;height: 100px;" v-else @click="uppic">

                                <div style="display: none;">
                                  <input class="CSChatThai" type="file" name="file1"  @change="previewImageprofiles" accept="image/*" id="uploadpicprofilechat"/>
                                </div>
                                <label for="SettingImg" class="SettingImgBtn" @click="uppictest">
                                  {{$t('Settings.editProfile.changePictureProfile')}}
                                </label>
                              </v-layout>
                              <input data-v-0c521aa4="" type="file" name="file" id="uploadpicprofilechat" class="SettingImgInput" @change="previewImageprofiles">
                            </div>
                          </div>
                          <p class="EditAreaNote">{{$t('Settings.editProfile.support')}} .JPEG/.PNG/.GIF</p><p class="EditAreaNote"></p><p class="EditAreaNote"></p>
                        </div>

                      </li>
                    </ul>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12 xl12 >
                    <h3  class="header">{{$t('Settings.editProfile.profile')}}</h3>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12 xl12 >
                    <div class="Setting">
                    <!---->
                      <div  class="SettingBlock">
                        <p class="SettingTtl">{{$t('Settings.editProfile.displayName')}}</p>
                        <div>
                          <div class="EditArea" v-if="!editname">
                            <v-layout align-center justify-center column>
                              <div class="EditAreaCont BreakWord">{{ name }}</div>
                              <v-btn flat small class="buttonedit" @click="editname = !editname">
                                <span >{{$t('AnswerQuestion.edit')}}</span>
                              </v-btn>
                            </v-layout>
                          </div>
                          <div class="EditArea" v-else>
                            <div  class="EditAreaCont">
                              <div  class="EditAreaContFlex"><!---->
                                <input type="text" placeholder="ชื่อผู้ใช้" class="InputEdit" v-model="nameedit">
                              </div>
                              <p class="EditAreaNote" style="color:red;" v-if="nameedit == ''">{{ alerterror }}</p>
                              <v-layout align-center justify-center row>
                                <v-btn flat small class="buttonedit" :loading="loading" :disabled="loading" @click="updatename()">
                                  <span >{{$t('AnswerQuestion.update')}}</span>
                                </v-btn>
                                <v-btn flat small class="buttoncancel" @click="cancelname()">
                                  <span >{{$t('AnswerQuestion.cancel')}}</span>
                                </v-btn>
                              </v-layout>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--  -->
                      <div  class="SettingBlock">
                        <p class="SettingTtl">{{$t('Settings.editProfile.status')}}</p>
                        <div>
                          <div class="EditArea" v-if="!editstatus">
                            <v-layout align-center justify-center column>
                              <div class="EditAreaCont BreakWord" v-if="status !== ''">{{ status }}</div>
                              <div class="EditAreaCont BreakWord" v-else>-</div>
                              <v-btn flat small class="buttonedit" @click="editstatus = !editstatus">
                                <span >{{$t('AnswerQuestion.edit')}}</span>
                              </v-btn>
                            </v-layout>
                          </div>
                          <div class="EditArea" v-else>
                            <div  class="EditAreaCont">
                              <div  class="EditAreaContFlex"><!---->
                                <input type="text" placeholder="สถานะ" class="InputEdit" v-model="statusedit">
                              </div>
                              <p class="EditAreaNote" style="color:red;" v-if="statusedit == ''">{{ alerterror }}</p>
                              <v-layout align-center justify-center row>
                                <v-btn flat small class="buttonedit"  :loading="loading" :disabled="loading" @click="updatestatus()">
                                  <span >{{$t('AnswerQuestion.update')}}</span>
                                </v-btn>
                                <v-btn flat small class="buttoncancel" @click="cancelstatus()">
                                  <span >{{$t('AnswerQuestion.cancel')}}</span>
                                </v-btn>
                              </v-layout>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- edit phone -->
                       <div class="SettingBlock">
                        <p class="SettingTtl">{{$t('Settings.editProfile.phone')}}</p>
                        <div>
                          <div class="EditArea" v-if="!editphone">
                            <v-layout align-center justify-center column>
                              <div class="EditAreaCont BreakWord">{{ phone }}</div>
                              <v-btn flat small class="buttonedit" @click="statusEditphone()">
                                <span >{{$t('AnswerQuestion.edit')}}</span>
                              </v-btn>
                            </v-layout>
                          </div>
                          <div class="EditArea" v-else>
                            <div  class="EditAreaCont">
                              <div  class="EditAreaContFlex">
                                <input type="text" :placeholder="$t('Settings.editProfile.phone')" class="InputEdit" v-model="phoneedit">
                              </div>
                              <p class="EditAreaNote" style="color:red;" v-if="phoneedit == ''">{{ alerterror }}</p>
                              <v-layout align-center justify-center row>
                                <v-btn flat small dark class="buttonedit"  :loading="loadingUpdatePhone" :disabled="disableupdatephone()"  @click="updatephone()">
                                  <span >{{$t('AnswerQuestion.update')}}</span>
                                </v-btn>
                                <v-btn flat small class="buttoncancel" @click="cancelphone()">
                                  <span >{{$t('AnswerQuestion.cancel')}}</span>
                                </v-btn>
                              </v-layout>
                            </div>
                          </div>


                        </div>
                      </div>
                      <!---->
                       <div  class="SettingBlock">
                        <p class="SettingTtl">{{$t('Settings.editProfile.email')}}</p>
                        <div>
                          <div class="EditArea">
                            <div class="EditAreaCont BreakWord">{{ email }}</div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </v-flex>

                  <!-- edit usrname and password -->
                  <v-flex sm12 md12 lg12 xl12 v-if="status_username === 'false'">
                    <h3 class="header">{{$t('Settings.editProfile.settingusername')}}</h3>
                  </v-flex>
                  <v-flex sm12 md12 lg12 xl12 v-if="status_username === 'false'">
                    <div class="Setting">
                    <!---->
                      <div class="SettingBlock">
                        <!-- <p class="SettingTtl">{{$t('Settings.editProfile.usernamepassword')}}</p> -->
                        <div>
                          <div class="EditArea" v-if="!editusername">
                            <v-layout column justify-center align-center>
                              <div class="EditAreaCont BreakWord" v-if="!loadingname">{{$t('Settings.editProfile.usernamepassword')}}</div>
                              <div v-else class="EditAreaCont BreakWord">
                                <v-progress-linear :indeterminate="loadingname"></v-progress-linear>
                              </div>

                              <v-btn flat small dark class="buttonedit" @click="editusername = !editusername">
                                <span >{{$t('AnswerQuestion.edit')}}</span>
                              </v-btn>
                            </v-layout>
                          </div>
                          <div class="EditArea" style="align-items: start !important;" v-else>
                            <div class="EditAreaCont">
                              <v-layout column justify-center alignCenter>
                                <v-text-field
                                  :placeholder="$t('Settings.editProfile.username')"
                                  v-model="username"
                                  :rules="usernameRules"
                                  :error="chkUsernameDuplicate"
                                  :error-messages="msgUsernameDuplicate"
                                  @input="changeUsername"
                                  @keypress="isNumandaz($event)"
                                  autocapitalize="off"
                                  required
                                  solo
                                  ></v-text-field>

                                  <v-text-field
                                    :placeholder="$t('Settings.editProfile.password')"
                                    v-model="password"
                                    :append-icon="e1 ? 'visibility' : 'visibility_off'"
                                    :append-icon-cb="() => (e1 = !e1)"
                                    :type="e1 ? 'text' : 'password'"
                                    :rules="passwordRules"
                                    required
                                    solo
                                    @keypress="isnotthai($event)"
                                  ></v-text-field>

                                  <v-text-field
                                    :placeholder="$t('Settings.editProfile.confirmpassword')"
                                    v-model="confirmpassword"
                                    :append-icon="e2 ? 'visibility' : 'visibility_off'"
                                    :append-icon-cb="() => (e2 = !e2)"
                                    :type="e2 ? 'text' : 'password'"
                                    :rules="repasswordRules"
                                    required
                                    solo
                                    @keypress="isnotthai($event)"
                                  ></v-text-field>
                                  <v-layout row wrap justify-center align-center>
                                    <v-btn flat small dark class="buttonedit" :loading="loadingname" :disabled="checkData()" @click="updateusername()">
                                      <span>{{$t('AnswerQuestion.update')}}</span>
                                    </v-btn>
                                    <v-btn flat small class="buttoncancel" @click="cancelusername()">
                                      <span>{{$t('AnswerQuestion.cancel')}}</span>
                                    </v-btn>
                                  </v-layout>
                              </v-layout>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </v-flex>

                  <v-flex sm12 md12 xs12 >
                    <h3  class="header">{{$t('Settings.editProfile.qrcodeForAddFriend')}}</h3>
                  </v-flex>
                  <v-flex sm12 md12 xs12>
                    <div class="Setting">
                      <div class="SettingBlock">
                        <div class="SettingQr">
                          <!-- <p class="SettingTtl" >QR code</p>  -->
                          <p class="SettingQrImg">
                            <qrcode :value="tokenuserQR" style="width: 180px; height: 180px;" id="downloadqr-profile"></qrcode>
                          </p>
                        </div>
                        <p class="SettingQrNote">{{$t('Settings.editProfile.detailQRcode')}}
                        <a href="#" class="button" id="btn-download-profile" :download="'qrcode_user_' + name + '.png'" @click="loadqr()">{{$t('AnswerQuestion.download')}}</a></p>
                      </div>
                    </div>
                  </v-flex>
            </v-layout>
          </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
  </div>
</vue100vh>
</template>
<script>
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'
import vue100vh from 'vue-100vh'
export default {
  data () {
    return {
      loading: false,
      phone: '',
      email: '',
      token: '',
      name: '',
      status: '',
      profilepicture: '',
      nameedit: '',
      statusedit: '',
      phoneedit: '',
      editname: false,
      editstatus: false,
      typeuser: '',
      alerterror: '',
      business_id: '',
      tokenuserQR: '',
      username: '',
      usernameedit: '',
      editusername: false,
      loadingname: false,
      password: '',
      confirmpassword: '',
      username_alerterror: '',
      password_alerterror: '',
      confirm_alerterror: '',
      editphone: false,
      phoneedit: '',
      // usernameRules: [
      //   v => !!v || '' || this.$t('Settings.messageError.UsernameRules1'),
      //   v => ((!v && v.length < 6) || /^[^\W_]+$/.test(v)) || this.$t('Settings.messageError.UsernameRules2'),
      //   v => (!!v && v.length >= 6) || this.$t('Settings.messageError.UsernameRules3'),
      //   v => /^([^A-Z])+$/.test(v) || this.$t('Settings.messageError.UsernameRules4'),
      //   v => /^([a-z])+$/.test(v) || /^((?=.*[a-z])(?=.*[0-9]).{6,})+$/.test(v) || this.$t('Settings.messageError.UsernameRules5'),
      //   v => this.checkUsernameDuplicate() || ''
      // ],
      // repasswordRules: [
      //   v => !!v || this.$t('Settings.messageError.RePasswordRules1'),
      //   v => v === this.password || this.$t('Settings.messageError.RePasswordRules2')
      // ],
      // passwordRules: [
      //   v => !!v || this.$t('Settings.messageError.PasswordRules1'),
      //   v => /^((?=.*[a-zA-Z])(?=.*[0-9]).{8,})+$/.test(v) || this.$t('Settings.messageError.RePasswordRules2')
      // ],
      chkUsernameDuplicate: false,
      msgUsernameDuplicate: [],
      e1: false,
      e2: false,
      usernameRules: [
        v => !!v || '' || this.$t('Settings.messageError.UsernameRules1'),
        v => (!!v && v.length >= 6) || this.$t('Settings.messageError.UsernameRules3'),
        v => this.checkUsernameDuplicate() || '',
        v => this.regular_username_mobile()
      ],
      passwordRules: [
        v => !!v || this.$t('Settings.messageError.PasswordRules1'),
        v => this.regular_pass_mobile()
      ],
      repasswordRules: [
        v => !!v || this.$t('Settings.messageError.RePasswordRules1'),
        v => v === this.password || this.$t('Settings.messageError.RePasswordRules2'),
        v => this.regular_repass_mobile()
      ],
      status_username: '',
      loadingUpdatePhone: false
    }
  },
  components: {
    vue100vh
  },
  methods: {
    regular_username_mobile () {
      this.username = this.username.replace(/[^a-z-0-9]/i, '')
      this.username = this.username.toLowerCase()
    },
    regular_pass_mobile () {
      this.password = this.password.replace(/^[ก-๛]+/i, '')
    },
    regular_repass_mobile () {
      this.confirmpassword = this.confirmpassword.replace(/^[ก-๛]+/i, '')
    },
    cancelusername () {
      this.editusername = !this.editusername
      // this.usernameedit = this.username
      this.username = ''
      this.password = ''
      this.confirmpassword = ''
    },
    updateusername () {
      var body = {
        'tokenuser': this.token,
        'username': this.username,
        'password': this.password
      }
      // console.log(process.env.APImanage + '/set_username', body)
      this.loadingname = true
      this.axios.post(process.env.APImanage + '/set_username', body).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.$swal('', this.$t('Alert.Success.settingusername'), 'success')
          localStorage.setItem('status_username', 'true')
          this.status_username = 'true'
        }
         else {
           this.loadingname = false
           this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
           localStorage.setItem('status_username', 'false')
           this.status_username = 'false'
           this.cancelusername()
         }
      }).catch(error => {
        console.log(error)
        this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
      })
    },
    checkData () {
      return (this.username === '' || this.password === '' || this.confirmpassword === '')
    },
    changeUsername () {
      if (this.chkChangeUsername) {
        this.chkChangeUsername = false
        this.msgUsernameDuplicate = []
        this.chkUsernameDuplicate = false
      }
    },
    checkUsernameDuplicate () {
      // console.log(this.username)
      if (this.username !== '') {
        this.axios.get(process.env.ONEID_API + '/check_username?username=' + this.username).then((response) => {
          // console.log(response.data)
          if (response.status === 200) {
            if (response.data.message === 'Success') {
              this.chkUsernameDuplicate = false
              this.msgUsernameDuplicate = []
            }
          }
        }, (error) => {
          if (error.response.status === 400) {
            if (error.response.data.errorMessage === 'username duplicate') {
              this.chkUsernameDuplicate = true
              this.msgUsernameDuplicate = [this.$t('Settings.messageError.UsernameDuplicate')]
              this.valid = false
            } else if (this.username === '') {
              this.msgUsernameDuplicate = [this.$t('Settings.messageError.UsernameRules1')]
            }
          }
        })
        return true
      }
    },
    isNumandaz ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      // console.log(keyCode)
      if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 97 && keyCode <= 122)) { // 46 is dot
        $event.preventDefault();
      }
    },
    isnotthai ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode >= 3585 && keyCode <= 3642) || (keyCode >= 3647 && keyCode <= 3675)) { // 46 is dot
        $event.preventDefault();
      }
    },
    toPage (data) {
      this.$router.push(data)
    },
    uppictest () {
      $('#uploadpicprofilechat').click()
    },
    uppic () {
      $('#uploadpicprofilechat').click()
    },
    cancelstatus () {
      this.editstatus = !this.editstatus
      this.statusedit = this.status
    },
    cancelname () {
      this.editname = !this.editname
      this.nameedit = this.name
    },
    updatename () {
      this.editname = !this.editname
      if (this.nameedit !== '') {
        this.loading = true
        this.axios.post(process.env.APImanage + '/setnameuser', {tokenuser: this.token, name: this.nameedit, business_id: this.business_id, type_user: this.typeuser}).then((response) => {
          if (response.data.status === 'success') {
            this.name = this.nameedit
            localStorage.setItem('name', this.nameedit)
            this.myname = this.nameedit
            this.loading = false
          }
        }, (response) => {})
      } else {
        this.nameedit = ''
        this.alerterror = 'กรุณากรอกชื่อผู้ใช้'
        this.editname = !this.editname
        this.loading = false
      }
    },
    updatestatus () {
      this.loading = true
      this.editstatus = !this.editstatus
      this.axios.post(process.env.APImanage + '/setstatususer', {tokenuser: this.token, status: this.statusedit}).then((response) => {
        if (response.data.status === 'success') {
          localStorage.setItem('status', this.statusedit)
          this.status = this.statusedit
          this.loading = false
        }
      }, (response) => {})
    },
    previewImageprofiles (data) {
      this.selectFile = data.target.files[0]
      var uploadFile = new FormData()
      uploadFile.append('file', this.selectFile, this.selectFile.name)
      uploadFile.append('tokenuser', this.token)
      uploadFile.append('business_id', this.business_id)
      uploadFile.append('type_user', this.typeuser)
      this.axios.post(process.env.APImanage + '/setpictureprofileuser', uploadFile).then((response) => {
        if (response.data.status === 'success') {
          this.profilepicture = response.data.filename
          localStorage.setItem('profilepicture', this.profilepicture)
          this.myprofilepicture = this.profilepicture
        }
      })
    },
    loadqr () {
      var cnvs = document.getElementById('downloadqr-profile')
      var button = document.getElementById('btn-download-profile')
      var dataURL = cnvs.toDataURL('image/png')
      button.href = dataURL
    },
    disableupdatephone () {
      if(this.phoneedit == '' || this.phoneedit == this.phone){
        return true
      }else{
        return false
      }
    },
    updatephone () {
      this.loadingUpdatePhone = true
      this.axios.post(process.env.APImanage + '/check_phone_login', {
        phone: this.phoneedit
      }).then((response) => {
        // console.log(response.data.status)
        if(response.data.status === 'success'){
           this.loadingUpdatePhone = false
          // console.log(response.data.message)
          if(response.data.message === 'non registered'){
            localStorage.typeAccount = true
            // localStorage.phonRecent = this.phone
          }else if(response.data.message === 'registered'){
            localStorage.typeAccount = false
            // localStorage.phonRecent = this.phone
          }
          localStorage.phonRecent = this.phone
          localStorage.phoneEdit = this.phoneedit
          this.editphone = !this.editphone
        this.$router.push('/mobile/settings/profile/editphone')
        }else{

        }
      }).catch((err)=>{
        console.log(err)
      })

    },
    statusEditphone () {
      this.$swal({
        title: this.$t('Settings.messageEditPhone.ChangePhoneNumber'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        // console.log(result.value)
        if(result.value === true){
          this.editphone = !this.editphone
        }else{
        }
      })
    },
    cancelphone () {
      this.editphone = !this.editphone
      this.phoneedit = this.phone
    },
  },
  computed: {
    ...sync('*')
  },
  watch: {
    myprofilepicture () {
      this.profilepicture = localStorage.getItem('profilepicture')
    },
    myname () {
      this.name = localStorage.getItem('name')
    },
    mystatus () {
      this.status = localStorage.getItem('status')
    }
  },
  created () {
    this.phone = localStorage.getItem('phone')
    this.email = localStorage.getItem('email')
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.status_username = localStorage.getItem('status_username')
    // this.status_username = 'true'
    // console.log(this.status_username)
    this.tokenuserQR = process.env.APIQRcode + '/qrcode/friend?id=' + btoa(this.token)
    this.name = localStorage.getItem('name')
    this.status = localStorage.getItem('status')
    this.profilepicture = localStorage.getItem('profilepicture')
    this.typeuser = localStorage.getItem('type_user')
    this.nameedit = this.name
    this.phoneedit = this.phone
    this.statusedit = this.status
    this.business_id = localStorage.getItem('business_id')
    this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
  }
}
</script>
<style type="text/css" scoped>
>>>.v-input__slot {
  width: 100% !important;
  box-sizing: border-box !important;
  background-color: rgb(255, 255, 255) !important;
  border: 1px solid rgb(210, 216, 221) !important;
  border-radius: 4px !important;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  box-shadow: none !important;
}
>>>.v-messages__message {
  line-height: 1 !important;
  word-break: break-word !important;
  word-wrap: break-word !important;
  hyphens: auto !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
>>>.canvas {
    /* width: 300px; */
    /* height: 300px; */
}
>>>.v-toolbar {
  /* box-shadow: none; */
  box-shadow: 0 2px 0px -1px hsla(0,0%,100%,.12), 0 0px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12) !important;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.edit {
  font-weight: 100;
}
.inputWrapper {
    height: 32px;
    width: 90px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
}
.img {
  display: block;
  max-width:230px;
  max-height:95px;
  width: auto;
  height: auto;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.dialog .dialog--active .dialog--persistent {
  max-height: 107vh;
  overflow: hidden;
}
.card__text {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  overflow: hidden;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.textbusiness {
  margin-top: 1vh;
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
  /*width: 300px;*/
}
input[type=textprofile] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    /*background-image: url('../assets/image/group.png');*/
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 10px 10px 10px 10px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
input[type=textprofile]:disabled {
    background: #cac9c9;
}
.EndpointUrl:hover .urlcopymessageapi {
  display: inline !important;
}
.urlcopymessageapi {
  display: none !important;
}
.EndpointUrl {
  display: block;
  /*color: #6D7D8D;*/
}
.header {
    display: block;
    font-size: 1.17em;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    margin: 40px 0 20px;
    padding-left: 20px;
    line-height: 1.3;
    font-weight: bold;
    font-size: 16px;
    position: relative;
    color: black !important;
}
.header::before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    width: 0;
    height: 32px;
    border-left: 4px solid #1a76d2;
}
.Setting {
    margin-bottom: 2vh;
}
.SettingBlock {
    padding: 30px 20px;
    border-top: 1px solid #DEE5EC;
}
.SettingBlock > :last-child {
    margin-bottom: 0;
}
.List_Register {
    margin-bottom: 32px;
    box-sizing: border-box;
}
.List_Register .List_item:last-child {
    border-bottom: none;
}
.List_Register .List_item {
    display: -webkit-flex;
    display: flex;
    padding: 0;
}
.List_Register .List_item:last-child .List_item_header {
    width: 200px;
}
.SettingTtl {
    margin-bottom: 8px;
    font-weight: bold;
    white-space: nowrap;
    color: black !important;
}
.md91SettingImg {
    padding-bottom: 12px;
    line-height: 1;
}
.SettingImgWrap {
    display: inline-block;
    position: relative;
    border-radius: 19px;
    overflow: hidden;
}
.SettingImgMask {
   position: relative;
    width: 160px;
    height: 160px;
    overflow: hidden;
    border-radius: 40px;
}

.SettingImgBtn {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 30px;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .5);
}

.SettingImgBtn:hover {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 50%;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .75);
}
.SettingImgInput {
    position: absolute;
    left: -9999px;
}
.EditAreaNote {
    margin: 8px 0 0;
    font-size: 13px;
    color: #BEC8D2;
    font-size: 12px;
}
.EditArea {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
}
.BreakWord {
    white-space: pre-wrap;
    word-break: break-all;
    word-break: break-word;
    word-wrap: break-word;
}
.EditAreaCont {
    width: 100%;
    padding-right: 1em;
    box-sizing: border-box;
}
.SettingQr {
    display: -webkit-flex;
    display: flex;
    justify-content: center;
}
.SettingQrImg {
    margin: 0 50px;
    position: relative;
}
.SettingQrNote {
    margin-bottom: 0;
    font-size: 13px;
}
.buttonedit {
  color: ghostwhite !important;
  border-radius: 4px !important;
  background-color: #2562af !important;
  border: solid 1px #2562af !important;
  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none !important;
}
.buttoncancel {
  color: black !important;
  border-radius: 4px !important;
  background-color: #c1c1c196 !important;
  border: solid 1px #c1c1c1 !important;
  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none !important;
}
.EditAreaContFlex {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
}

.InputEdit {
    width: 100%;
    padding: 10px 15px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.BGwhite {
  background-color: white !important;
}
/*.avatarpicBis:hover .overlay {
  opacity: 1;

}*/
</style>



// WEBPACK FOOTER //
// src/components/mobile/settings/Editprofile.vue